import VideoConferencesNotificationsContainer from './video-conferences-notifications-container';

export default VideoConferencesNotificationsContainer;
